//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getFieldConfig} from '../source.js';
import dynamicSingleField from '../source-common-module/dynamic-single-field';
import dynamicMultField from '../source-common-module/dynamic-mult-field';

export default {
  name: "prity-offer",
  components: {
    dynamicSingleField,
    dynamicMultField
  },
  data() {
    return {
      roundId: null,
      priceList: [],
      sourceName: null,
      sourceNum: null,
      selectModel: 'offer',
      supList: [],
      matList: [],
      showType: 'sup',
      supplierAttachment: [],
      parityDto: {},
      parityId: null,
      scoreShow: false,
      scoreMenus: [],
      hiddenPrice: false,
      hiddenAttach: false,
      showAttach:null
    }
  },
  methods: {
    viewField(field, dynamicData) {
      this.$refs.multMatDynamic.initData(field, dynamicData);
    },
    backLast() {
      this.$router.go(-1);
    },
    getRoation() {
      let that = this;
      return new Promise(function (resolve, reject) {
        that.$get(`api/sourceRotation/${that.roundId}`).then((res) => {
          that.sourceName = res.sourceProject;
          that.sourceNum = res.sourceNum;
          resolve(res);
        }).catch((err) => {
          reject(err);
        })
      })
    },
    getPriceList() {
      let that = this;
      return new Promise(function (resolve, reject) {
        that.$get(`api/sourceComparePriceDt/start-comparing`, {rotationIds: that.roundId}).then((res) => {
          that.priceList = res;
          resolve(res);
          that.priceDeal();
        }).catch((err) => {
          reject(err);
        })
      })
    },
    priceDeal() {
      let supObj = {};
      let matObj = {};
      if (this.priceList && this.priceList.length) {
        this.priceList.forEach((item) => {
          if (!item.dataFromId) {
            return;
          }
          if (supObj[item.type + item.dataFromId + item.supplierId]) {
            supObj[item.type + item.dataFromId + item.supplierId].push(item);
          } else {
            supObj[item.type + item.dataFromId + item.supplierId] = [item];
          }
          if (matObj[item.materialName]) {
            matObj[item.materialName].push(item);
          } else {
            matObj[item.materialName] = [item];
          }
        });
        let supLists = [];
        let matLists = [];
        for (let k in supObj) {
          let obj = {};
          obj.dataFromName = supObj[k][0].dataFromName;
          obj.round = supObj[k][0].round;
          obj.supplierName = supObj[k][0].supplierName;
          obj.type = supObj[k][0].type;
          obj.dataFromId = supObj[k][0].dataFromId;
          obj.supplierId = supObj[k][0].supplierId;
          obj.beginDate = supObj[k][0].beginDate;
          obj.endDate = supObj[k][0].endDate;
          obj.matList = supObj[k];
          supLists.push(obj);
        }
        for (let k in matObj) {
          let obj = {};
          obj.materialName = matObj[k][0].materialName;
          obj.materialCode = matObj[k][0].materialCode;
          obj.fieldNameAndValueList = matObj[k][0].fieldNameAndValueList;
          obj.matList = matObj[k];
          matLists.push(obj);
        }
        this.supList = supLists;
        this.matList = matLists;
        this.matList.forEach((item) => {
          item.matList.forEach((item2) => {
            item[item2.type + item2.dataFromId + item2.supplierId] = item2;
          })
        });
        if (this.supList.length > 0) {
          let list = this.supList.map((sup) => {
            let obj =  {
              sourceRoationId: sup.dataFromId,
              round: sup.round,
              supplierId: sup.supplierId,
              supplierName: sup.supplierName,
              dataFromName: sup.dataFromName,
            };
            if(this.showAttach){
              obj.showAttach = this.showAttach;
            }
            return obj;
          });
          this.$post('api/sourceComparePriceDt/get-supplier-attachment', list).then((res) => {
            this.supplierAttachment = res;
          })
        }
        this.getPriceTemplates();
      } else {
        this.selectModel = 'attach';
        let list;
        if (this.roundId) {
          list = [
            {
              sourceRoationId: this.roundId
            }
          ]
        } else {
          list = this.parityDto.sourceRotationList.map(function (sup) {
            return {
              sourceRoationId: sup.id
            }
          });
        }
        this.$loadingShow();
        this.$post('api/sourceComparePriceDt/get-supplier-attachment', list).then((res) => {
          this.supplierAttachment = res;
          this.$loadingHide();
        }).catch(() => {
          this.$loadingHide();
        })
      }
    },
    getParityDto() {
      this.$loadingShow();
      this.$get(`api/sourceComparePrice/${this.parityId}`).then((res) => {
        if (res) {
          this.parityDto = res;
          if (res.sourceComparePriceDtList) {
            this.priceList = res.sourceComparePriceDtList;
          }

          this.priceDeal();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    },
    changeShowModel(str) {
      this.selectModel = str;
    },
    changeShow(obj) {
      if (obj.cellShow) {
        this.$set(obj, 'cellShow', false);
        return;
      }
      this.$set(obj, 'cellShow', true);
    },
    changeSelected(data, str) {
      this.$set(data, 'showInfoType', str);
    },
    viewScore(item) {
      this.scoreMenus = [];
      item.rattingList.forEach((score) => {
        this.scoreMenus.push({label: score.name, scoreItem: score});
      });
      this.scoreShow = true;
    },
    clickMenu(e, item) {
      if (item) {
        this.$router.push(`/auditing-score/detail/${item.scoreItem.schemeDetailsId}/${item.scoreItem.scoringObjectId}?view=true`);
      }
    },
    getPriceTemplates() {
      let priceTemIds = [];
      this.priceList.forEach((item) => {
        if (item.sourcePriceTemplateId) {
          priceTemIds.push(item.sourcePriceTemplateId);
        }
        item.offerFieldList = [];
        item.inquiryFieldList = [];
      });
      let set = new Set(priceTemIds);
      let priceTemsObs = [];
      set.forEach((item) => {
        priceTemsObs.push(new Promise((resolve, reject) => {
          this.$get(`api/sourcePriceTemplate/${item}`).then((res) => {
            resolve(res);
          }).catch((err) => {
            reject(err);
          })
        }))
      });
      Promise.all(priceTemsObs).then((res) => {
        this.priceList.forEach((item) => {
          let temList = res.filter((template) => {
            return template.id === item.sourcePriceTemplateId;
          });
          if (temList && temList[0]) {
            item.offerFieldList = getFieldConfig(temList[0]).offerFieldList;
            item.inquiryFieldList = getFieldConfig(temList[0]).inquiryFieldList;
            this.$set(item,'priceTemplateObj',temList[0]);
          }
        });
      });
    }
  },
  mounted() {
    if (this.$route.params.roundId) {
      this.roundId = this.$route.params.roundId;
      this.$loadingShow();
      Promise.all([this.getRoation(), this.getPriceList()]).then((res) => {
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      });
    }
    if (this.$route.params.parityId) {
      this.parityId = this.$route.params.parityId;
      this.getParityDto();
    }
    if (this.$route.query.hiddenPrice) {
      this.hiddenPrice = true;
      this.selectModel = 'attach';
    }
    if (this.$route.query.hiddenAttach) {
      this.hiddenAttach = true;
    }
    if(this.$route.query.showAttach){
      this.showAttach = this.$route.query.showAttach;
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/price-parity/parity-offer.vue